import { render, staticRenderFns } from "./RowDetailsSelect.vue?vue&type=template&id=1957557a"
import script from "./RowDetailsSelect.vue?vue&type=script&lang=js"
export * from "./RowDetailsSelect.vue?vue&type=script&lang=js"
import style0 from "./RowDetailsSelect.vue?vue&type=style&index=0&id=1957557a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1957557a')) {
      api.createRecord('1957557a', component.options)
    } else {
      api.reload('1957557a', component.options)
    }
    module.hot.accept("./RowDetailsSelect.vue?vue&type=template&id=1957557a", function () {
      api.rerender('1957557a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/RowDetailsSelect.vue"
export default component.exports